import * as d3 from 'd3';
import { Block, EditMode } from '../types';
import { getBpmnSymbol } from '../../data/bpmnSymbols';
import { setupTextEditing } from './textEditor';

const CAPTION_FONT_PX = 10;

/** Libellé affiché : texte utilisateur en priorité, sinon nom du symbole BPMN. */
export function getBpmnCaptionLabel(block: Block): string {
  const userText = (block.text || '').trim();
  if (userText) return userText;
  const def = block.bpmnSymbol ? getBpmnSymbol(block.bpmnSymbol) : undefined;
  return def?.label || '';
}

export function appendBpmnMeaningCaption(
  container: d3.Selection<HTMLDivElement, unknown, null, undefined>,
  block: Block,
  symbolHeight: number,
  symbolWidth: number,
  editMode?: EditMode,
  onTextUpdate?: (id: string, newText: string) => void,
): HTMLElement | null {
  const label = getBpmnCaptionLabel(block);
  if (!label) return null;

  const captionEl = container
    .append('div')
    .attr('class', 'bpmn-meaning-caption')
    .text(label)
    .style('position', 'absolute')
    .style('left', '50%')
    .style('top', `${symbolHeight + 6}px`)
    .style('transform', 'translateX(-50%)')
    .style('box-sizing', 'border-box')
    .style('max-width', `${Math.max(symbolWidth + 16, 128)}px`)
    .style('padding', '3px 7px')
    .style('border-radius', '4px')
    .style('background', '#fff')
    .style('border', '1px solid #d1d5db')
    .style('box-shadow', '0 1px 2px rgba(15, 23, 42, 0.08)')
    .style('color', '#374151')
    .style('font-size', `${CAPTION_FONT_PX}px`)
    .style('font-weight', '500')
    .style('line-height', '1.25')
    .style('letter-spacing', '0.01em')
    .style('text-align', 'center')
    .style('white-space', 'normal')
    .style('pointer-events', editMode?.enabled ? 'auto' : 'none')
    .style('cursor', editMode?.enabled ? 'text' : 'default')
    .style('z-index', '7')
    .node();

  if (captionEl instanceof HTMLElement && editMode?.enabled && onTextUpdate) {
    setupBpmnCaptionEditing(captionEl, block, onTextUpdate);
  }

  return captionEl instanceof HTMLElement ? captionEl : null;
}

export function setupBpmnCaptionEditing(
  element: HTMLElement,
  block: Block,
  onUpdate: (id: string, newText: string) => void,
) {
  setupTextEditing(element, block, true, (id, newText) => {
    onUpdate(id, newText);
    element.textContent = getBpmnCaptionLabel({ ...block, text: newText });
  });
}
